const inventoryPricingState = {};

export default inventoryPricingState;
